import script from "./footNav.vue?vue&type=script&setup=true&lang=js"
export * from "./footNav.vue?vue&type=script&setup=true&lang=js"

import "./footNav.vue?vue&type=style&index=0&id=1999a1a7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1999a1a7"]])

export default __exports__